import {
  SET_STARTING_POINT,
  SET_DESTINATION,
  DirectionsActionsTypes,
} from "./DirectionsActions";

interface Directions {
  startingPoint: any;
  destination: any;
}

const initialState: Directions = { startingPoint: {}, destination: {} };

const DirectionsReducer = (
  state = initialState,
  action: DirectionsActionsTypes
) => {
  switch (action.type) {
    case SET_STARTING_POINT:
      return {
        ...state,
        startingPoint: action.payload?.id ? { ...action.payload } : {},
      };
    case SET_DESTINATION:
      return {
        ...state,
        destination: action.payload?.id ? { ...action.payload } : {},
      };
    default:
      return state;
  }
};

export default DirectionsReducer;
